import { useSelector } from 'react-redux'
import _ from 'lodash'

import { useFilterTours } from './useFilterTours'
import { getFilters } from '../redux/reducers/filters'
import { getTours } from '../redux/reducers/tours'

export function useGetFilteredToursWithException(exception) {
  const filterState = useSelector(getFilters)
  const tours = useSelector(getTours)

  const filterStateWithException = _.omit(filterState, exception)

  return useFilterTours(tours, filterStateWithException)
}
